import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchConfig } from "@/lib/api";
import { loadTikTokPixel, ttqTrack } from "@/lib/tiktok";

const ConfigContext = createContext({ config: null, loading: true });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchConfig()
      .then((data) => {
        if (!active) return;
        setConfig(data);
        if (data.tiktok_pixel_id) {
          loadTikTokPixel(data.tiktok_pixel_id);
          ttqTrack("ViewContent", { content_name: "Pronto.AI Landing" });
        }
      })
      .catch(() => setConfig({ checkout_url: "", tiktok_pixel_id: "", price: "R$ 4,99" }))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}

// Abre o checkout configurado. Se CHECKOUT_URL estiver vazio, informa o usuário.
export function goToCheckout(config, source = "cta") {
  ttqTrack("ClickButton", { content_name: source });
  const url = config && config.checkout_url;
  if (url) {
    ttqTrack("InitiateCheckout", { value: 4.99, currency: "BRL", content_name: "Pronto.AI" });
    window.location.href = url;
    return true;
  }
  return false;
}
